// extracted by mini-css-extract-plugin
export default {"confettiVideo":"Confetti_confettiVideo__4XHqe"};